<template>
  <Layout>
    <div class="mc-unsubscribe__form">
      <div class="mc-unsubscribe__form-wrapper mc-unsubscribe__form-wrapper--digest">
        <h4 class="mc-unsubscribe__label">
          {{ title }}
        </h4>
        <p>
          {{ subTitle }}
        </p>
        <FormulateForm v-model="formValues">
          <div v-for="reason in reasonList" :key="reason.key" class="d-flex gap-2">
            <McCheckbox :id="`checkbox-${reason.key}`" v-model="selected[reason.key]" />
            <label :for="`checkbox-${reason.key}`">{{ reason.label }}</label>
          </div>
          <FormulateInput
            v-model="formValues.reason"
            type="textarea"
            name="reason"
            class="mc-unsubcribe__textarea"
            :label="$t('unsubscribe.digest.reason.other')"
            :placeholder="$t('unsubscribe.digest.reason.fillText')"
            validation="max:300,length"
            :validation-name="$t('unsubscribe.digest.otherReasons')"
            error-behavior="live"
          />
          <McButton
            class="mt-3"
            :text="$t('unsubscribe.digest.unsubscribe')"
            size="full"
            :tooltipText="$t('unsubscribe.digest.tooltip')"
            :disabled="!isFormValid"
            displayTooltip
            block
            @click="submitForm"
          />
        </FormulateForm>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@/router/layouts/auth'
import appConfig from '@/app.config'
import { Helper } from '@/mixin/helper'
import McCheckbox from '@/components/McCheckbox'
import McButton from '@/components/McButton'
import { UNSUBSCRIBE_DIGEST } from '@/services/api/unsubscribe'

export default {
  page: {
    title: 'Unsubscribe',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    McCheckbox,
    McButton,
  },
  mixins: [Helper],
  data() {
    return {
      formValues: {},
      selected: {},
    }
  },
  computed: {
    type() {
      const mappingType = {
        daily: this.$t('global.time.daily'),
        weekly: this.$t('global.time.weekly'),
        monthly: this.$t('dashboard.text.costPeriod.last12Months'),
      }
      return mappingType[this.$route.params.type]
    },
    title() {
      return this.$t('unsubscribe.digest.title', { type: this.type })
    },
    subTitle() {
      return this.$t('unsubscribe.digest.subTitle')
    },
    reasonList() {
      return [
        {
          key: 'spam',
          label: this.$t('unsubscribe.digest.reason.spam'),
          value: 'Terlalu Sering',
        },
        {
          key: 'not-relevant',
          label: this.$t('unsubscribe.digest.reason.notRelevant'),
          value: 'Informasi kurang relevan dengan kebutuhan',
        },
        {
          key: 'not-useful',
          label: this.$t('unsubscribe.digest.reason.notUseful'),
          value: 'Data tidak membantu saya mengambil keputusan',
        },
        {
          key: 'too-much',
          label: this.$t('unsubscribe.digest.reason.tooMuch'),
          value: 'Terlalu banyak informasi',
        },
      ]
    },
    isFormValid() {
      return (
        this.selected.spam ||
        this.selected['not-relevant'] ||
        this.selected['not-useful'] ||
        this.selected['too-much'] ||
        !!this.formValues.reason
      )
    },
    token() {
      const currentUrl = new URL(window.location.href)
      const searchParams = new URLSearchParams(currentUrl.search)
      return searchParams.get('token')
    },
  },
  methods: {
    async submitForm() {
      const selectedReasons = this.reasonList
        .filter((reason) => this.selected[reason.key])
        .map((reason) => reason.value)
        .join('||')

      const allReasons = [selectedReasons, this.formValues.reason].filter(Boolean).join('||')
      const input = {
        token: this.token,
        comment: allReasons,
      }

      const res = await this.$apollo.mutate({
        mutation: UNSUBSCRIBE_DIGEST,
        variables: {
          input: input,
        },
      })

      if (res.data.unsubscribeDigest.isSuccessful) {
        this.$router.push({
          name: 'Unsubscribe Digest Result',
          params: {
            type: this.$route.params.type,
          },
        })
      } else {
        this.$mcToast.error(res.data.unsubscribeDigest.message)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../style.scss';
</style>
